import React, { useEffect, useState } from 'react';
import { Card, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import ENDPOINT from '../../data/ENDPOINT';

const Company = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(ENDPOINT+"fetch-organizations.php") // Update with actual API path
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setCompanies(data.organizations);
        } else {
          console.error("Error fetching data");
        }
        setLoading(false);
      })
      .catch(error => {
        console.error("Error:", error);
        setLoading(false);
      });
  }, []);

  return (
    <Container className="mt-5 mb-5">
      {/* Title Section */}
      <div className="text-center">
        <h2 className="fw-bold">Top Companies</h2>
      </div>


      {/* Show Loading State */}
      {loading ? (
        <div className="text-center mt-4">
          <Spinner animation="border" />
        </div>
      ) : (
        <Row className="mt-3 g-4 justify-content-center animation-active ">
          {companies.map((company, index) => (
            <Col key={index} xs={12} sm={6} md={4} lg={3} className={"d-flex justify-content-center"+" fade-in-bottom "+"delay"+index+"s"}>
              <Card className="text-center shadow-sm position-relative" style={{ width: '18rem', borderRadius: '12px' }}>
                <div className="bg-primary rounded-top p-5"></div>

                <Card.Img
                  variant="top"
                  src={company.image} // Ensure DB has image_url column
                  alt={company.name}
                  className="rounded-circle mx-auto d-block"
                  style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '-50px' }}
                />

                <Card.Body>
                  <h5>{company.name}</h5>
                  <p className="text">{company.about_organization}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default Company;
